module.exports = __webpack_public_path__ + "img/choose-icon03.b21c3850.png";